export const currentLangage = localStorage.getItem("currentLangage") || "fr";
